import React from 'react'
import { Space } from 'antd'
import { Text } from '../../../styles/reactnative'
import SettingChange from './ExChangeSetting/SettingChange'
import HumanSettingChange from './HumanSettingChange'

export const humanevent_columns = (mutate, usermodal) => {
	return [
		{
			title: '내용',
			dataIndex: 'desc',
			key: 'desc',
			width: 500,
			render: (text, record) => (
				<Space.Compact
					style={{
						textAlign: 'left',
						alignItems: 'flex-start',
						justifyContent: 'flex-start',
						alignContent: 'flex-start',
					}}>
					<Text style={{ textAlign: 'left' }}>
						{text?.substr(text?.indexOf(':') + 1)}
					</Text>
				</Space.Compact>
			),
		},
		{
			title: '설정값',
			dataIndex: 'setting',
			key: 'setting',
			align: 'left',
			render: (text, record) => (
				<HumanSettingChange data={record} mutate={mutate} />
			),
		},
	]
}
